import { Entity } from "@/shared/state/visualization/schema/v1/three-d";

import styles from "./EntityConfig.module.css";
import { MeshConfig } from "./MeshConfig";
import { PathConfig } from "./PathConfig";
import { PositionConfig } from "./PositionConfig";

interface EntityConfigProps {
  entity: Entity;
  panelId: string;
}

export function EntityConfig({ entity, panelId }: EntityConfigProps) {
  return (
    <>
      <div className={styles.spacer} />
      <PositionConfig entity={entity} panelId={panelId} />
      <div className={styles.spacer} />
      <MeshConfig entity={entity} panelId={panelId} />
      <div className={styles.spacer} />
      <PathConfig entity={entity} panelId={panelId} />
    </>
  );
}
